<template>
  <div>
  <table class="table table-bordered" v-if="subjectList.length>0">
      <thead>
        <tr>
          <td class="text-center">Sl.No</td>
          <td class="text-center">Subject</td>
          <td class="text-center">Subject Name</td>
          <td class="text-center">Max. Marks</td>
          <td class="text-center">Obtained Marks</td>
        </tr>
      </thead>
      <tbody>
      <template v-if="markentryConf.subjectConf.displaySubjectBy=='TABLE'">
        <tr v-for="(mark, idx) in markList" :key="mark.subjectId">
          <td class="text-center">{{ idx + 1 }}</td>
          <td>{{ mark.subjectName }}</td>
          <td></td>
          <td class="text-center">{{ mark.maxMark }}</td>
          <td class="text-center">
            <input type="text" class="form-control" v-model="mark.markObtained" />
          </td>
        </tr>
        </template>
        <template v-else-if="markentryConf.subjectConf.displaySubjectBy=='DROPDOWN'">
            <markentryRow v-for="(mark, idx) in markList" :key="idx" :subject-list="subjectList" :mark="mark" :idx="idx"></markentryRow>
        </template>
        <tr>
            <td colspan='3' class='text-right'><b>TOTAL</b></td>
            <td class="text-center bold">{{totalMax}}</td>
            <td class="text-center bold">{{totalObtained}}</td>
        </tr>
        <tr>
            <td colspan='3' class='text-right bold'>PERCENTAGE</td>
            <td colspan='2' class="text-center bold">{{totalPercentage}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from "lodash";
import markentryRow from "./dropdownMarkEntryRow.vue";

export default {
  name: "table-markentry",
  components:{
      markentryRow
  },
  props:{
      subjectList:{
          type:Array,
          default(){
              return []
          }
      },
      markList:{
          type:Array,
          default(){
              return []
          }
      },
      markentryConf:Object
  },
  computed: {
    totalMax(){
      return _.sumBy(this.markList, subject=> Number(subject.maxMark));
    },
    totalObtained(){
         return _.sumBy(this.markList, function(subject){return subject.markObtained?Number(subject.markObtained):0;});
    },
    totalPercentage(){
        if(this.totalMax && this.totalObtained){
            return ((this.totalObtained/this.totalMax)*100).toFixed(2);
        }
        return 0;
        
    }
  }
}
</script>

<style>

</style>